module.exports = __webpack_public_path__ + "img/11.457d8643.png";